/**
 * CommentsCell - the Comments column in the Opportunities and Projects tables.
 *
 * Shows EVERY comment on the row, oldest first so it reads like a thread. It
 * used to show only the newest with the rest behind a hover popover, which
 * meant reading a busy project one mouse-over at a time. Taller rows are the
 * trade, and they were asked for.
 *
 * Deliberately the twin of TasksCell: two columns side by side that behave
 * differently are worse than a little duplication.
 *
 * Rows come from the table's ONE indexed fetch (useCommentsIndex).
 */
import { fmtDate } from '../../utils/format';
import { severityTone } from '../../data/projectHealth';

const BLUE = '#1565C0';

export default function CommentsCell({ comments }) {
  // Sorted here rather than trusting the caller, then reversed to read
  // oldest-first the way a conversation does.
  const rows = [...(comments || [])].sort((a, b) => String(a.created_at || '').localeCompare(String(b.created_at || '')));

  if (!rows.length) return <span style={{ color: '#C9C9C9', fontSize: 10.5 }}>-</span>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, minWidth: 0 }}>
      {rows.map((c) => {
        // A comment written against a yellow/red flag wears that colour.
        const tone = severityTone(c.severity);
        return (
          <div key={c.id} style={{ display: 'flex', gap: 5, alignItems: 'flex-start', minWidth: 0 }}>
            <span
              style={{
                flexShrink: 0,
                marginTop: 3.5,
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: tone ? tone.dot : BLUE,
              }}
            />
            <span style={{ minWidth: 0 }}>
              <span
                style={{
                  display: 'block',
                  fontSize: 10,
                  lineHeight: 1.35,
                  wordBreak: 'break-word',
                  color: tone ? tone.fg : '#333',
                  fontWeight: tone ? 600 : 400,
                }}
              >
                {c.body}
              </span>
              <span style={{ display: 'block', fontSize: 8.5, marginTop: 1, color: '#9A9A9A' }}>
                {c.author || 'Unknown'} · {fmtDate(c.created_at)}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
